import { QuantityInput } from "./styles";

export default function QuantitySelector({ value, onChange }) {
  return <QuantityInput type="number" min="0" value={value} onChange={onChange} />;
}
